import { useTextDomainContext } from "@/app/providers";
import { useContext } from "react";

export const useDocumentTypeArray = () => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  return [
    { value: "energy-contract", label: gettext("Energy Contract") },
    { value: "green-certificates", label: gettext("Green Certificates") },
    { value: "co2-certificates", label: gettext("Co2 Certificates") },
    { value: "invoices", label: gettext("Invoices") },
    { value: "energy-report", label: gettext("Energy report") },
    { value: "climate-report", label: gettext("Climate report") },
    { value: "others", label: gettext("Others") },
  ];
};
